document.addEventListener('DOMContentLoaded', () => {
    let add_note_action_item = document.querySelector('#add_new_note_action_item')
    if (add_note_action_item !== null) {
        document.querySelector('#titlebar_right .action_items').appendChild(add_note_action_item);
    }
});
